import { routerStyxie } from '@/router/styxieBridge'
import { useMlapProjectStore } from '@/stores/mlapProject'
import { useMlapProjectPagesStore } from '@/stores/mlapProjectPages'

// Client-side routed under the project layout: the payload seeds the project
// store and the dashboard page for the first render, later entries fetch the
// /mlap/ajax twins (see router/routes/mlap.js).
Styxie.Initializers.MlapProjects = routerStyxie({
  actions: ['show'],
  hydrate: (props, pinia) => {
    useMlapProjectStore(pinia).hydrate(props.project)
    const pages = useMlapProjectPagesStore(pinia)
    pages.hydrateMeta(props)
    pages.hydratePage('dashboard', { hiddenCardKeys: props.hiddenCardKeys, trendsMetricColors: props.trendsMetricColors })
  }
})
